import Section from '@components/Section';
import Title from '@components/Title';
import Underline from '@components/Underline';
import WorkItem from '@components/WorkItem';
import WORKS from '@consts/works';
import useWindowDimensions from '@hooks/useWindowDimensions';
import React, { useMemo } from 'react';
import Slider from './Slider';


interface IWorksProps {
  children?: React.ReactNode;
}

const Works:React.FC<IWorksProps> = (props) => {
  const { width } = useWindowDimensions();

  const renderItems = () => {
    return WORKS.map(w => (
      <WorkItem key={w.title} {...w} />
    ))
  }

  const showSlider = width !== undefined && width >= 1024;

  const renderedItems = useMemo(() => {
    if (showSlider) return (
      <Section id='Recent Works'>
        <Slider items={renderItems()} />
      </Section>
    );
    return (
      <Section id='Recent Works'>
        <Title size={32}>Recent <Underline>Works</Underline></Title>
        {renderItems()}
      </Section>
    );
  }, [showSlider]);

  return renderedItems;
}

export default Works;
